// import { collection, getDocs, query, doc, getDoc, addDoc, deleteDoc, updateDoc, setDoc, where } from "firebase/firestore";
import { collection, getDocs, query, where} from "firebase/firestore";
import { db } from '../config/firebase'

export const getAlertsData = () => {
    return getDocs(query(collection(db, "alertas"), where("activo", "==", true)))
}